export default __webpack_public_path__ + "static/media/scaredInTheDark.a32cf3a2.jpeg";